import { batch } from 'react-redux';
import { restorePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { ItemListActions } from 'src/common/redux/reducers/item-list-reducer';
import { applyCartResponse } from 'src/home-page/business-logic/common/apply-cart-response';
import { searchTransaction } from 'src/search/business-logic/handle-search';
import { LocalStorage } from '../../common/helpers/local-storage';
import {
  IMergeTransactionParams,
  mergeTransaction,
  salesTransactionBegin,
} from '../../common/helpers/transaction-helper';
import { store } from '../../common/redux/configure-store';
import { TransactionActions } from '../../common/redux/reducers/transaction-reducer';
import { voidActiveTransaction } from '../../home-page/business-logic/void-transaction';
import { getInterventions } from '../../interventions/business-logic/get-interventions';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { closeSearchModal } from '../../search/search';
import { showMergeTransactionPage } from '../components/merge-transaction';

export const initializeMergeTransaction = (): void => {
  const onCancel = (): void => {
    restorePage();
  };

  const onList = (): void => {
    onCancel();
    searchTransaction({
      submitCallback: onTransctionSubmitCallback,
      submitButtonText: 'Merge_Transaction_Command',
    });
  };

  const onSubmit = (barcode: string): Promise<void> => {
    return mergeTransactionHandler(barcode, true, '')
      .then(() => restorePage())
      .catch(popupMessage);
  };

  const onTransctionSubmitCallback = (transactionId: string, touchPointId: string): void => {
    mergeTransactionHandler(transactionId, false, touchPointId)
      .then(() => {
        closeSearchModal();
        restorePage();
      })
      .catch(popupMessage);
  };

  const onScan = async (scanData: string): Promise<void> => {
    await mergeTransactionHandler(scanData, true)
      .then(() => restorePage())
      .catch(popupMessage);
  };

  showMergeTransactionPage({ onCancel, onList, onSubmit }, onScan);
};

export const mergeTransactionHandler = async (
  transactionNumber: string,
  isBarCode: boolean,
  tillId?: string,
): Promise<void> => {
  const transactionState = store.getState().transaction;
  const isNoSaleMode = !transactionState.transactionIdExists;
  const storeId = LocalStorage.storeId();
  const currentTillId = LocalStorage.tillId();
  const currentTransactionId = transactionState.transactionId;

  const params: IMergeTransactionParams = {
    currentTillId: currentTillId,
    currentTransactionId: currentTransactionId,
    isBarCode: isBarCode,
    tillId: tillId ? tillId.toString() : '',
    transactionNumber: transactionNumber,
  };

  if (isNoSaleMode) {
    await salesTransactionBegin(storeId, params.currentTillId, false).then(cartResponse => {
      const cartResponseId = cartResponse.cartId ?? '';
      batch((): void => {
        store.dispatch(TransactionActions.setTransactionId(cartResponseId));
        store.dispatch(
          TransactionActions.setTransactionSequenceNumber(cartResponse.sequenceNumber ?? 0),
        );
      });
      params.currentTransactionId = cartResponseId;
    });
  }

  return mergeTransaction(params)
    .then(cartResponse => {
      const cartResponseId = cartResponse.cartId ?? '';
      batch(() => {
        store.dispatch(TransactionActions.setTransactionId(cartResponseId));
        store.dispatch(
          TransactionActions.setTransactionSequenceNumber(cartResponse.sequenceNumber ?? 0),
        );
        store.dispatch(ItemListActions.removeAllRecords());
        applyCartResponse(cartResponse);
      });
      getInterventions().catch(() => {});
    })
    .catch(err => {
      if (isNoSaleMode) {
        voidActiveTransaction();
      }
      throw err;
    });
};
